module.exports = __webpack_public_path__ + "img/25.257f98bf.jpg";